<template>
  <div class="router-wrapper">
    <div v-show="product" class="element-wrapper">
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
      <div class="os-tabs-w">
        <div class="os-tabs-controls os-tabs-complex">
          <div class="nav-item">
            <h1>{{ $t("products_edit.heading") }}</h1>
          </div>
          <div class="nav-item nav-actions d-none d-sm-block">
            <button type="button" class="button" color="primary" size="medium" v-on:click="send">
              {{ $t("general.save") }}
            </button>
          </div>
        </div>
      </div>

      <div class="content-box">
        <h4 v-if="product.product_name">
          {{ $t(product.product_name.lang_code + ".full") }}
          {{ product.diameter }} x {{ product.length }} {{ $t("general.edit") }}
        </h4>

        <div
          class="modal fade"
          id="selectTemplateModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="selectTemplateModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="selectTemplateModalLabel">
                  {{ $t("reports_create.select_test_template") }}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>
                        {{ $t("general.test_template") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="filteredTemplates(product).length > 0" style="cursor: pointer">
                    <tr
                      v-for="template in filteredTemplates(product)"
                      data-dismiss="modal"
                      v-on:click="addTemplate(template)"
                      v-bind:key="template.id"
                    >
                      <td>{{ template.name }}</td>
                    </tr>
                  </tbody>
                  <tr v-else style="font-style: italic; text-align: center">
                    <td>{{ $t("products_edit.no_test_templates") }}</td>
                  </tr>
                </table>
              </div>
              <div class="modal-footer"></div>
            </div>
          </div>
        </div>

        <div class="element-box">
          <div class="steps-w">
            <div class="step-triggers">
              <a class="step-trigger" v-on:click="changeTab(1)" v-bind:class="getClassForTab(1)">
                <span
                  v-if="
                    errors.items.filter(e => !e.field.startsWith('value_') && !e.field.startsWith('template_')).length >
                      0
                  "
                  class="has-error-title"
                >
                  <i class="fas fa-exclamation"></i>
                </span>
                {{ $t("products_edit.master_data") }}
              </a>
              <a class="step-trigger" v-on:click="changeTab(2)" v-bind:class="getClassForTab(2)">
                <span v-if="errors.items.filter(e => e.field.startsWith('value_')).length > 0" class="has-error-title">
                  <i class="fas fa-exclamation"></i>
                </span>
                {{ $t("characteristics.assign_characteristics") }}
              </a>
              <a class="step-trigger" v-on:click="changeTab(3)" v-bind:class="getClassForTab(3)">
                <span v-if="product.templates.filter(t => !t.isValid).length > 0" class="has-error-title">
                  <i class="fas fa-exclamation"></i>
                </span>
                {{ $t("products_edit.assign_test_template") }}
              </a>
            </div>
            <div class="step-contents">
              <div class="step-content" v-bind:class="{ active: currentTab == 1, hide: currentTab != 1 }">
                <product-properties :product="product" v-if="didFinishLoading" :is-editing="true" />
              </div>
              <div class="step-content" v-bind:class="{ active: currentTab == 2, hide: currentTab != 2 }">
                <div class="pipeline-w">
                  <div class="row">
                    <div class="col-6">
                      <div class="pipeline pipeline-fullheight white lined-success">
                        <div class="pipeline-header">
                          <h5 class="pipeline-name">
                            {{ $t("characteristics.assigned_characteristics") }}
                          </h5>
                        </div>
                        <div class="pipeline-wrapper">
                          <div class="pipeline-wrapped" id="scrollContainer">
                            <div class="pipeline-body assigned">
                              <div
                                class="pipeline-item assigned"
                                v-for="c in assignedCharacteristics"
                                :key="c.id"
                                :id="'assigned' + c.id"
                                style="cursor: default"
                              >
                                <div class="pi-controls">
                                  <div class="pi-settings">
                                    <div class="badge badge-primary float-right">
                                      {{ c.category }}
                                    </div>
                                  </div>
                                </div>
                                <div class="pi-body">
                                  <div
                                    class="avatar"
                                    style="cursor: pointer"
                                    v-on:click="removeCharacteristicFromSelected(c)"
                                  >
                                    <i class="fas fa-minus"></i>
                                  </div>
                                  <div class="pi-info">
                                    <div class="pi-name">
                                      <span class="h6">{{ c.localizedKey }}</span>
                                      -
                                      {{ c.unit.name }}
                                    </div>
                                    <!--
                                                                  <div class="form-group">
                                                                      <input :class="{'is-invalid': errors.has('value_' + c.id) }"
                                                                          :name="'value_' + c.id"
                                                                          v-model="c.value" v-validate="'required'"
                                                                          class="form-control"
                                                                          placeholder="Wert" type="text">

                                    </div>-->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="pipeline pipeline-fullheight white lined-primary">
                        <div class="pipeline-header">
                          <h5 class="pipeline-name">
                            {{ $t("characteristics.available_characteristics") }}
                          </h5>
                        </div>
                        <div class="pipeline-wrapper">
                          <div class="pipeline-wrapped" id="scrollAvailableContainer">
                            <div class="pipeline-body available">
                              <div
                                class="pipeline-item"
                                v-for="c in characteristics"
                                :key="c.id"
                                style="cursor: default"
                                :id="'available' + c.id"
                              >
                                <div class="pi-controls">
                                  <div class="pi-settings">
                                    <div class="badge badge-primary float-right">
                                      {{ c.category }}
                                    </div>
                                  </div>
                                </div>
                                <div class="pi-body">
                                  <div
                                    class="avatar"
                                    style="cursor: pointer"
                                    v-on:click="addCharacteristicToSelected(c)"
                                  >
                                    <i class="fas fa-plus"></i>
                                  </div>
                                  <div class="pi-info">
                                    <div class="pi-name">
                                      <span class="h6">{{ c.localizedKey }}</span>
                                      -
                                      {{ c.unit.name }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="step-content" v-bind:class="{ active: currentTab == 3, hide: currentTab != 3 }">
              <div class="row mt-5">
                <div class="col-12">
                  <div class="support-index show-ticket-content show-ticket-content-assign-templates">
                    <div class="support-tickets" id="templateCards">
                      <div class="support-tickets-header">
                        <div class="tickets-control tickets-control-assign-templates">
                          <h5>{{ $t("general.test_template") }}</h5>
                          <!-- Button trigger modal -->
                          <button
                            type="button"
                            class="button"
                            color="primary"
                            data-toggle="modal"
                            data-target="#selectTemplateModal"
                          >
                            {{ $t("products_edit.add_test_template") }}
                          </button>
                        </div>
                        <div
                          class="support-ticket template-ticket"
                          :class="{
                            active: template.id == selectedTemplate.id,
                            'has-error': !template.isValid
                          }"
                          v-on:click="changeTemplate(template)"
                          v-for="template in product.templates"
                          v-bind:key="template.id"
                        >
                          <div class="st-body">
                            <div class="avatar template-error" v-show="!template.isValid">
                              <i class="fas fa-exclamation"></i>
                            </div>
                            <div class="ticket-content">
                              <h6 class="ticket-title" :class="{ 'has-error-title': !template.isValid }">
                                {{ template.name }}
                              </h6>
                            </div>
                          </div>
                          <div class="row st-foot">
                            <div class="col-11">
                              {{ template.characteristics.length }}
                              {{ $t("characteristics.available_characteristics") }}
                            </div>
                            <div class="col-1">
                              <div class="float-right">
                                <span v-if="!deletedTemplates.find(t => t.id == template.id)">
                                  <i
                                    class="far fa-trash-alt"
                                    style="cursor: pointer; color: #e65252"
                                    v-on:click="showConfirmationDialog(template)"
                                  ></i>
                                </span>
                                <span v-else style="color: #0a0b0b">
                                  <clip-loader :loading="true" :size="'20px'"></clip-loader>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="support-ticket-content-w">
                      <div class="support-ticket-content">
                        <div class="ticket-thread ticket-thread-assign-templates">
                          <table class="table table-hover">
                            <thead>
                              <tr>
                                <th></th>
                                <th scope="col">
                                  {{ $t("characteristics.characteristic") }}
                                </th>
                                <th scope="col">
                                  {{ $t("products_edit.range_value") }}
                                </th>
                                <th scope="col"></th>
                              </tr>
                            </thead>
                            <tr
                              v-for="c in selectedTemplate.characteristics"
                              style="height: 45px"
                              v-if="c.show"
                              v-bind:key="c.id"
                            >
                              <td>
                                <input v-model="c.isSelected" type="checkbox" />
                              </td>

                              <td>
                                {{ c.localizedKey }} <b>{{ c.shortcut }}</b>
                              </td>

                              <!-- TEXT INPUT -->
                              <td v-if="isText(c.dataType)">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-group">
                                      <label>{{ $t("general.text") }}</label>
                                      <input
                                        v-model="c.value1"
                                        v-bind:name="'value1' + c.id"
                                        class="form-control"
                                        v-bind:placeholder="$t('general.text')"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <!--FLOAT INPUT -->
                              <td v-else-if="isFloat(c.dataType)">
                                <div class="row">
                                  <div class="col-6">
                                    <div class="form-group">
                                      <label>{{ $t("general.min") }}</label>
                                      <input
                                        v-model="c.value1"
                                        class="form-control"
                                        placeholder="9999.00"
                                        :name="'template_min' + c.id"
                                        :class="{
                                          'is-invalid': errors.has('template_min' + c.id) && c.isSelected
                                        }"
                                        v-validate="
                                          c.isSelected
                                            ? {
                                                required: false,
                                                regex: /^-?[0-9/.]*$/
                                              }
                                            : null
                                        "
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <div class="form-group">
                                      <label>{{ $t("general.max") }}</label>
                                      <input
                                        v-model="c.value2"
                                        class="form-control"
                                        :name="'template_max' + c.id"
                                        :class="{
                                          'is-invalid': errors.has('template_max' + c.id) && c.isSelected
                                        }"
                                        v-validate="{
                                          required: false,
                                          regex: /^-?[0-9/.]*$/
                                        }"
                                        placeholder="9999.00"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <!-- BOOLEAN INPUT -->
                              <td v-else-if="isBoolean(c.dataType)">
                                <div class="row">
                                  <div class="col-12">
                                    <div class="form-check">
                                      <label class="form-check-label">
                                        <input v-model="c.value1" class="form-check-input" type="checkbox" />
                                        {{ $t("general.value_required") }}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td></td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-lg-12">
            <button type="button" class="button" size="max" color="primary" v-on:click="send">
              {{ $t("general.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import draggable from "vuedraggable";
import { i18n } from "@/lang";
import settings from "@/settings.json";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { isBooleanCharacteristic, isFloatCharacteristic, isTextCharacteristic } from "@/utils/characteristic-data-type";
import lodash from "lodash";
import ProductProperties from "@/components/products/partials/edit/product-properites";

export default {
  name: "ProductsEdit",
  components: {
    draggable,
    ClipLoader,
    "product-properties": ProductProperties
  },
  data() {
    return {
      product: {
        characteristics: [],
        templates: [],
        properties: {}
      },
      characteristics: [],
      templates: [],
      selectedTemplate: {
        characteristics: []
      },
      currentTab: 1,
      didFinishLoading: false,
      assignedCharacteristics: [],
      deletedTemplates: [],
      scrollToAssigned: null,
      scrollToAvailable: null
    };
  },
  methods: {
    ...mapActions("productStore", ["fetchSingle"]),
    ...mapActions({
      updateProduct: "productStore/update",
      removeTemplateFromProduct: "templateStore/removeTemplateFromProduct"
    }),
    send() {
      // set order
      this.product.templates.forEach((template, _) => {
        template.characteristics = template.characteristics.filter(c => c.show);
      });

      this.saveAssignedCharacteristics();

      this.$validator.validateAll().then(valid => {
        if (valid) {
          const properties = this.product.properties;
          const dropdownProperties = [];
          const textProperties = [];
          this.productInfo.fields.forEach(field => {
            const property = properties[field.id];

            if (property === undefined) {
              return;
            }

            if (field.isDropdown) {
              const p = {
                property: field.id,
                values: []
              };

              if (field.allowsMultiple) {
                p.values = property.map(value => {
                  return { id: `${value.propertyId || value.id}` };
                });
              } else if (field.hasCustomValues) {
                p.values.push({ customValue: property.name });
              } else {
                p.values.push({ id: `${property.propertyId || property.id}` });
              }

              dropdownProperties.push(p);
            } else {
              textProperties.push({
                property: field.id,
                value: lodash.isPlainObject(property) ? property.value || "" : property || ""
              });
            }
          });

          const variables = {
            textProperties: textProperties,
            dropdownProperties: dropdownProperties,
            assignedCharacteristics: this.product.productCharacteristics.map(c => c.id),
            assignedTemplates: this.product.templates.map(template => {
              const t = {};
              t.templateId = template.id;
              t.characteristics = template.characteristics
                .filter(c => c.isSelected)
                .map(chara => {
                  return {
                    characteristicId: chara.id,
                    value1: `${chara.value1}`
                      .replace(/null/g, "")
                      .replace(/true/g, "ok")
                      .replace(/false/g, "nok"),
                    value2: chara.value2
                  };
                });

              return t;
            }),
            productId: this.product.id
          };

          this.updateProduct(variables)
            .then(response => {
              if (response.data.editProduct === "success") {
                this.$router.push("/products");
              } else {
                alert("error");
              }
            })
            .catch(e => alert(e));
        }
      });
    },
    addTemplate(t) {
      this.product.templates.push(t);
      t.isValid = false;
      t.characteristics.forEach(c => {
        if (c.dataType === "BOOLEAN") {
          c.value1 = false;
        }
      });
      this.selectedTemplate = t;
    },
    changeTemplate(t) {
      this.selectedTemplate = t;
    },
    changeTab(to) {
      this.saveAssignedCharacteristics();
      this.currentTab = to;
    },
    getClassForTab(tab) {
      if (tab === this.currentTab) {
        return ["active", "complete"];
      } else {
        return ["tab-inactive"];
      }
    },
    addCharacteristicToSelected(characteristic) {
      this.characteristics = this.characteristics.filter(c => c.id !== characteristic.id);
      this.assignedCharacteristics.push(characteristic);

      this.assignedCharacteristics.sort((c1, c2) => c1.masterSort - c2.masterSort);

      this.scrollToAssigned = characteristic.id;
    },
    removeCharacteristicFromSelected(characteristic) {
      this.assignedCharacteristics = this.assignedCharacteristics.filter(c => c.id !== characteristic.id);
      this.characteristics.push(characteristic);
      this.characteristics.sort((c1, c2) => c1.masterSort - c2.masterSort);

      this.scrollToAvailable = characteristic.id;
    },
    shouldMove(evt, originalEvent) {
      return evt.from !== evt.to; // prevent dragging of item inside list
    },
    saveAssignedCharacteristics() {
      this.product.productCharacteristics = this.product.productCharacteristics.filter(characteristic => {
        return this.assignedCharacteristics.find(c => c.id === characteristic.id) != null;
      });

      this.assignedCharacteristics
        .filter(ac => !this.product.productCharacteristics.find(c => c.id === ac.id))
        .forEach(c => this.product.productCharacteristics.push(c));
    },
    filteredTemplates(product) {
      return this.templates.filter(t => !product.templates.find(t2 => t.id === t2.id));
    },
    removeTemplate(template) {
      const productId = this.product.id;
      const templateId = template.id;
      const data = { productId, templateId };
      this.deletedTemplates.push(template);

      this.removeTemplateFromProduct(data)
        .then(response => {
          const result = response.data.removeTemplateFromProduct;
          if (result === "IN_USE") {
            const obj = {
              title: this.$i18n.t("general.error.title"),
              message: this.$i18n.t("products_edit.test_template_remove_try_dialog.message"),
              type: "error"
            };
            this.$refs.simplert.openSimplert(obj);
          } else if (result === "DELETED") {
            this.selectedTemplate = {
              characteristics: []
            };
            this.product.templates = this.product.templates.filter(t => t.id !== template.id);
          } else {
            const obj = {
              title: "Error",
              message: "Unknown error",
              type: "error"
            };
            this.$refs.simplert.openSimplert(obj);
          }

          this.deletedTemplates = this.deletedTemplates.filter(t => t.id !== template.id);
        })
        .catch(e => {
          this.deletedTemplates = this.deletedTemplates.filter(t => t.id !== template.id);
          const obj = {
            title: "Error",
            message: "Unknown error",
            type: "error"
          };
          this.$refs.simplert.openSimplert(obj);
        });
    },
    showConfirmationDialog(template) {
      const fn = this.removeTemplate;
      const confirm = function() {
        fn(template);
      };
      const obj = {
        title: this.$i18n.t("general.confirm"),
        message: this.$i18n.t("products_edit.remove_template_dialog.message", {
          templateName: template.name
        }),
        type: "warning",
        customCloseBtnText: this.$i18n.t("general.cancel"),
        customConfirmBtnText: this.$i18n.t("general.remove"),
        useConfirmBtn: true,
        customConfirmBtnClass: "button-red",
        onConfirm: confirm
      };
      this.$refs.simplert.openSimplert(obj);
    },
    isText(dataType) {
      return isTextCharacteristic(dataType);
    },
    isBoolean(dataType) {
      return isBooleanCharacteristic(dataType);
    },
    isFloat(dataType) {
      return isFloatCharacteristic(dataType);
    }
  },
  computed: {
    ...mapState("productStore", ["productInfo"])
  },
  mounted() {
    const id = this.$route.params.id;

    if (id) {
      this.fetchSingle(id)
        .then(([templatesResponse, characteristicsResponse, productResponse]) => {
          this.templates = templatesResponse.map(t => {
            t.characteristics.forEach(c => {
              c.value1 = null;
              c.value2 = null;
              c.isSelected = true;
            });

            t.characteristics.sort((c1, c2) => c1.order - c2.order);
            return t;
          });

          this.characteristics = characteristicsResponse
            .map(c => {
              c.value = null;
              return c;
            })
            .sort((c1, c2) => c1.masterSort - c2.masterSort);

          this.product = productResponse;

          this.product.productCharacteristics = productResponse.productCharacteristics.map(c => {
            const characteristic = this.characteristics.find(ch => ch.id === c.id);
            characteristic.value = c.value;
            return characteristic;
          });

          if (productResponse.templates) {
            this.product.templates = productResponse.templates.map(t => {
              const template = Object.assign(
                {},
                this.templates.find(t1 => t1.id === t.id)
              );
              template.characteristics = t.productTemplateCharacteristics.sort((a, b) => a.order - b.order);
              template.characteristics.forEach(c => {
                c.isSelected = true;
                if (c.value1 === "ok") {
                  c.value1 = true;
                } else if (c.value1 === "nok") {
                  c.value1 = false;
                }
              });

              // add characteristics from template that were de-selected previously
              const characteristics = this.templates
                .find(t1 => t1.id === t.id)
                .characteristics.filter(c => !template.characteristics.find(tc => tc.id === c.id))
                .map(c => {
                  const chara = Object.assign({}, c);
                  chara.isSelected = false;
                  return chara;
                });

              template.characteristics.push(...characteristics);

              return template;
            });
          } else {
            this.product.templates = [];
          }

          // filter characteristics that are already assigned to the product
          this.characteristics = this.characteristics.filter(
            c => !this.product.productCharacteristics.find(c2 => c2.id === c.id)
          );

          // save product_properties_id to properties
          for (const key of Object.keys(this.product.properties)) {
            const property = this.productInfo.fields.find(p => p.id === key);
            const productPropertyId = this.product.properties[key].product_property_id;
            if (productPropertyId && property) {
              property.values.forEach(v => (v.product_property_id = productPropertyId));
            }

            if (property && property.hasCustomValues) {
              this.product.properties[key].name = this.product.properties[key].value;
            }

            if (property && !property.isDropdown) {
              this.product.properties[key] = this.product.properties[key].value;
            }
          }

          this.product.productCharacteristics.sort((c1, c2) => c1.masterSort - c2.masterSort);

          this.assignedCharacteristics = this.product.productCharacteristics.sort(
            (c1, c2) => c1.masterSort - c2.masterSort
          );

          this.didFinishLoading = true;
        })
        .catch(e => {
          alert(e);
          console.error(e);
        });
    }
  },
  watch: {
    product: {
      deep: true,
      handler(oldVal, newVal) {
        if (this.product.templates) {
          this.product.templates.forEach(template => {
            let valid = true;
            for (const c of template.characteristics) {
              c.show = this.assignedCharacteristics.find(c1 => c1.id === c.id) != null;
              if (!c.isSelected || !c.show) {
                continue;
              }
              if (c.dataType === "TEXT") {
                // valid = !!c.value1
              } else if (c.dataType === "FLOAT") {
                if (c.value1 && !/^-?[0-9/.]*$/.test(c.value1)) {
                  valid = false;
                } else if (c.value2 && !/^-?[0-9/.]*$/.test(c.value2)) {
                  valid = false;
                } else {
                  valid = true;
                }
              }

              if (!valid) {
                break;
              }
            }

            template.isValid = valid;
          });
        }

        if (this.assignedCharacteristics) {
          this.product.templates.forEach(template => {
            template.characteristics.forEach(c => {
              c.show = this.assignedCharacteristics.find(c1 => c1.id === c.id) != null;
            });
          });
        }
      }
    }
  },
  updated: function() {
    this.$nextTick(function() {
      if (this.scrollToAssigned) {
        const options = {
          container: "#scrollContainer",
          easing: "ease-in",
          offset: -60,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };

        this.$scrollTo("#assigned" + this.scrollToAssigned, 500, options);
        this.scrollToAssigned = null;
      }

      if (this.scrollToAvailable) {
        const options = {
          container: "#scrollAvailableContainer",
          easing: "ease-in",
          offset: -60,
          force: true,
          cancelable: true,
          x: false,
          y: true
        };

        this.$scrollTo("#available" + this.scrollToAvailable, 500, options);
        this.scrollToAvailable = null;
      }
    });
  }
};
</script>

<style scoped></style>
